import { Handle, Position } from "@xyflow/react";
import { Tooltip } from "antd";

export default PortWithLabel;

function PortWithLabel({ port, index, total }) {
  const left = `${((index + 0.5) / total) * 100}%`;

  return (
    <>
      <Tooltip title={port}>
        <Handle
          id={port}
          type="source"
          position={Position.Bottom}
          style={{ left }}
        />
      </Tooltip>
    </>
  );
}
